// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.training-container {
  padding-bottom: 32px;
}

.training-content {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.training-subtitle {
  color: var(--ui-muted);
  margin-top: -8px;
}

.training-feedback {
  border: 1px dashed var(--ui-border);
  border-radius: var(--ui-radius-md);
  padding: 16px;
  color: var(--ui-muted);
  background: #f8faff;
}

.training-feedback-error {
  border-color: #ef9b9b;
  color: #9e1d1d;
  background: #fff2f2;
}

.training-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
}

.training-card {
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-lg);
  background: var(--ui-surface);
  box-shadow: var(--ui-shadow-sm);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.training-video-wrapper {
  background: #111827;
  min-height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.training-video {
  width: 100%;
  max-height: 190px;
  background: #000000;
}

.training-video-fallback {
  color: #cfd7ea;
  font-weight: 600;
  padding: 20px;
  text-align: center;
}

.training-card-body {
  padding: 14px;
}

.training-card-body h3 {
  margin: 0 0 8px;
  font-size: 16px;
  color: var(--ui-primary);
}

.training-description {
  color: var(--ui-text);
  font-size: 14px;
  line-height: 1.45;
  margin-bottom: 10px;
}

.training-module {
  font-size: 13px;
  color: #2f3a56;
}

.training-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 6px;
  flex-wrap: wrap;
}

.training-pagination span {
  font-size: 14px;
  color: #41506f;
}

@media (max-width: 700px) {
  .training-grid {
    grid-template-columns: 1fr;
  }

  .training-video-wrapper {
    min-height: 140px;
  }

  .training-video {
    max-height: 170px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Treinamentos/training.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,6BAA6B;EAC7B,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".training-container {\n  padding-bottom: 32px;\n}\n\n.training-content {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.training-subtitle {\n  color: var(--ui-muted);\n  margin-top: -8px;\n}\n\n.training-feedback {\n  border: 1px dashed var(--ui-border);\n  border-radius: var(--ui-radius-md);\n  padding: 16px;\n  color: var(--ui-muted);\n  background: #f8faff;\n}\n\n.training-feedback-error {\n  border-color: #ef9b9b;\n  color: #9e1d1d;\n  background: #fff2f2;\n}\n\n.training-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 16px;\n}\n\n.training-card {\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-lg);\n  background: var(--ui-surface);\n  box-shadow: var(--ui-shadow-sm);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.training-video-wrapper {\n  background: #111827;\n  min-height: 160px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.training-video {\n  width: 100%;\n  max-height: 190px;\n  background: #000000;\n}\n\n.training-video-fallback {\n  color: #cfd7ea;\n  font-weight: 600;\n  padding: 20px;\n  text-align: center;\n}\n\n.training-card-body {\n  padding: 14px;\n}\n\n.training-card-body h3 {\n  margin: 0 0 8px;\n  font-size: 16px;\n  color: var(--ui-primary);\n}\n\n.training-description {\n  color: var(--ui-text);\n  font-size: 14px;\n  line-height: 1.45;\n  margin-bottom: 10px;\n}\n\n.training-module {\n  font-size: 13px;\n  color: #2f3a56;\n}\n\n.training-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin-top: 6px;\n  flex-wrap: wrap;\n}\n\n.training-pagination span {\n  font-size: 14px;\n  color: #41506f;\n}\n\n@media (max-width: 700px) {\n  .training-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .training-video-wrapper {\n    min-height: 140px;\n  }\n\n  .training-video {\n    max-height: 170px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
